import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 27 — Tour del catálogo de Productos.
 *
 * Cubre el flujo: cómo crear un producto, cómo vincularlo al inventario
 * (insumo + cantidad consumida), precio en paquete, stock con semáforo y
 * toggle activo/inactivo inline.
 */
export const tourProductos: TourDefinition = {
  id: 'productos',
  title: 'Cómo gestionar los Productos del menú',
  steps: [
    {
      element: '[data-tour="prod-header"]',
      popover: {
        title: '1. Catálogo de productos',
        description:
          'Aquí vive lo que el cliente pide del menú: cortes (Sirloin 1/4 kg), complementos (Pan Ajo), bebidas (Coca-Cola 600 ml), etc. Cada producto tiene su precio y su stock.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="prod-nuevo"]',
      popover: {
        title: '2. Crear un producto nuevo',
        description:
          'Toca este botón para agregar. Al abrir el formulario verás: nombre, tipo (corte/complemento/bebida), categoría, precio, unidad de venta (kg/pieza/litro), y opcionalmente un precio especial cuando va dentro de paquete.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prod-nuevo"]',
      popover: {
        title: '3. Vincular al inventario',
        description:
          'En el form, abajo verás "🔗 Vínculo a inventario". Elige el INSUMO del que se descuenta cada venta y "¿Cuánto consume?". Ejemplo: el producto "Sirloin 1/4 kg" consume 0.25 kg del insumo "Sirloin" (en cocido — el sistema convierte a crudo si hay merma).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prod-filtros"]',
      popover: {
        title: '4. Buscar y filtrar',
        description:
          'Busca por nombre (sin importar acentos) o filtra por categoría. Los productos más vendidos del mes aparecen primero — útil para encontrar rápido los que más mueves.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prod-tabla"]',
      popover: {
        title: '5. La tabla del catálogo',
        description:
          'Cada fila te muestra: precio (y precio en paquete si difiere), STOCK con semáforo (🟢 OK · 🟡 bajo · 🔴 crítico · AGOTADO), y cuántas veces se vendió este mes. El stock viene calculado en tiempo real del insumo vinculado.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="prod-tabla"]',
      popover: {
        title: '6. Acciones rápidas por fila',
        description:
          'El 👁 / 🙈 oculta o muestra el producto en el menú POS al instante (sin abrir formulario). El ✏ edita; el 🗑 elimina (sólo si nunca se ha vendido — los que tienen historial se ocultan con 👁 en su lugar).',
        side: 'top',
      },
    },
  ],
};
